document.addEventListener('click', function (e) {
  var swatch = e.target.closest('.product-item__swatch');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  var card = swatch.closest('.product-item');
  if (!card) return;

  // Update active state within THIS card only
  card.querySelectorAll('.product-item__swatch').forEach(function (s) {
    s.classList.remove('is-active');
  });
  swatch.classList.add('is-active');

  // Swap the primary card image to the selected colour's image
  var newSrc = swatch.getAttribute('data-image-src');
  if (newSrc) {
    var primaryFigure = card.querySelector('.product-item__image-figure--primary');
    var img = primaryFigure ? primaryFigure.querySelector('img.img') : null;
    if (img) {
      // Clear srcset/sizes first, otherwise the browser keeps using them over src
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = newSrc;

      var alt = swatch.getAttribute('data-image-alt');
      if (alt) img.alt = alt;
    }
  }

  // Point the card's links to the chosen variant so the colour persists on click
  var variantUrl = swatch.getAttribute('data-variant-url');
  if (variantUrl) {
    card.querySelectorAll('a.product-item__image, a.product-item__title').forEach(function (a) {
      a.setAttribute('href', variantUrl);
    });
  }
}, true); // capture phase ensures we beat the <a> link handler
